// components
import { SplashScreen } from 'src/components/loading-screen';
//
import { AuthContext } from './auth-context';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function AuthConsumer({ children }: Props) {
  console.log('I am here')
  return (
    <AuthContext.Consumer>
      {(auth: any) => (auth.loading ? <SplashScreen /> : children)}
    </AuthContext.Consumer>
  );
}
